import React, { Component } from 'react';
import { Provider } from 'react-redux';
import '../i18n';
import App from '../App.jsx';
import configureStore from '../store.jsx';
const store = configureStore();


export default class Root extends Component {
    render(){
        return (
            <Provider store={store}>
                <App />
            </Provider>
        )
    }
}